<template>
  <div>
    <header>
      <div class="main-header">
        <div class="container-fluid">
          <div class="menubar-flex">
            <div class="menubar-left">
              <a href="" class="main-logo">
                <div class="logo">
                  <img src="@/assets/images/logo/LOGO.png" alt="SIPAMER" />
                </div>
              </a>
            </div>
            <div class="menubar-right ml-auto">
              <nav class="main-nav">
                <ul>
                  <li>
                    <a href="#intro" class="nav-link page-scroll active"
                      >Beranda</a
                    >
                  </li>
                  <li>
                    <a href="#fitur" class="nav-link page-scroll"
                      >Fitur Aplikasi</a
                    >
                  </li>
                  <li>
                    <a href="#about" class="nav-link page-scroll"
                      >Tentang Sipamer</a
                    >
                  </li>
                  <li><a href="#wms" class="nav-link page-scroll">WMS</a></li>
                  <li><a href="#faq" class="nav-link page-scroll">Faq</a></li>
                  <li>
                    <a href="#contact" class="nav-link page-scroll">Kontak</a>
                  </li>
                </ul>
                <div class="box-btn">
                  <a href="/login" class="btn-gradient">
                    <div class="btn-gradient-hover purple"></div>
                    <div class="btn-text-gradient">Login</div>
                    <div class="btn-gradient-shine"></div>
                  </a>
                </div>
              </nav>
              <div class="btn-gradient navigation-burger d-xl-none">
                <div class="btn-gradient-hover purple"></div>
                <div class="btn-text-gradient">
                  <span></span>
                </div>
                <div class="btn-gradient-shine"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>


<script>
export default {};
</script>
